import React from 'react';
import { motion } from 'framer-motion';
export function AvatarPains() {
  const pains = [{
    emoji: '😔',
    text: <>
          Buscas patrones de amigurumis de mascotas y solo encuentras{' '}
          <span className="text-red-500 font-semibold" data-id="element-1">muñecos genéricos</span>{' '}
          que no se parecen en nada a tu peludo.
        </>
  }, {
    emoji: '😤',
    text: <>
          Has intentado adaptar patrones por tu cuenta, pero el resultado{' '}
          <span className="text-red-500 font-semibold" data-id="element-2">nunca se parece</span> a
          tu mascota real.
        </>
  }, {
    emoji: '💔',
    text: <>
          Quieres regalar algo hecho a mano que sea especial, no{' '}
          <span className="text-red-500 font-semibold" data-id="element-3">"otro peluche más"</span>{' '}
          del montón.
        </>
  }, {
    emoji: '😩',
    text: <>
          Te{' '}
          <span className="text-red-500 font-semibold" data-id="element-4">
            frustra invertir horas
          </span>{' '}
          tejiendo algo que al final no te convence y termina guardado en un
          cajón.
        </>
  }];
  return <section className="py-16 md:py-24 bg-linen" data-id="element-5">
      <div className="max-w-3xl mx-auto px-4" data-id="element-6">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-7">
          <p className="text-sm font-bold tracking-[0.2em] text-warm-brown uppercase mb-4" data-id="element-8">
            ¿Te suena familiar?
          </p>
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-deep-brown" data-id="element-9">
            Sabemos cómo te sientes...
          </h2>
        </motion.div>

        <div className="space-y-4" data-id="element-10">
          {pains.map((pain, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -15
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08,
          duration: 0.4
        }} className="etsy-card p-5 flex items-start gap-4" data-id="element-11">
              <span className="text-2xl flex-shrink-0 mt-0.5" data-id="element-12">
                {pain.emoji}
              </span>
              <p className="text-gray-600 leading-relaxed" data-id="element-13">{pain.text}</p>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.5
      }} className="text-center mt-10 text-warm-brown font-heading italic text-lg" data-id="element-14">
          Si dijiste "sí" a al menos una... sigue leyendo 👇
        </motion.p>
      </div>
    </section>;
}